/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */

import { path } from 'rambda';
import { defineModule } from 'direct-vuex';
import { modActionCtx, modGetterCtx } from '@/store/index';
import { api } from '@/utils/apiInstance';
import {
  ModalPurchasesInfoInterface,
} from '@/interfaces/purchasesInfoModalTypes';

import {
  FetchOfficeState,
  basicOfficeFetch,
  getFetchState,
  FetchStateInterface,
  getFetchMutations,
} from '@/store/storeUtils';
import {
  PENDING, REJECTED, INIT,
} from '@/utils/statuses';

export interface ModalPurchasesInfoStoreInterface extends FetchOfficeState<ModalPurchasesInfoInterface> {
  data: ModalPurchasesInfoInterface;
}

const ModalPurchasesInfoStore = defineModule({
  namespaced: true,
  state: {
    ...getFetchState<ModalPurchasesInfoInterface>(),
  } as FetchStateInterface<ModalPurchasesInfoInterface>,

  getters: {
    data(...args): ModalPurchasesInfoInterface | undefined {
      const { state } = getterCtx(args);

      const result = path(['data', 'data'], state.response) as ModalPurchasesInfoInterface;

      return result;
    },
  },
  mutations: {
    ...getFetchMutations(),
    SET_INIT(state) {
      state.fetchState = INIT;
    },
  },
  actions: {

    async fetch(ctx, props:{purchaseId: string}) {
      const { commit, state } = actionCtx(ctx);

      if (state.fetchState === PENDING) {
        return;
      }

      await basicOfficeFetch({
        method: api.office.sendPost,
        props: {
          url: '/transaction/marketplaceDetails',
          data: {
            id: props.purchaseId,
          },
        },
        setState: commit.SET_STATE,
        // update state
        callback: (fetchState) => {
          if (fetchState === REJECTED) {
            console.error('Fetch error in twoAuthCodeStore.fetch, status: ', REJECTED);
          }
        },
      });
    },
  },
});

export default ModalPurchasesInfoStore;
const getterCtx = (args: [any, any, any, any]) => modGetterCtx(args, ModalPurchasesInfoStore);
const actionCtx = (ctx: any) => modActionCtx(ctx, ModalPurchasesInfoStore);
